package org.zest.insan_360_website.pages.user

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.rememberCoroutineScope
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import org.zest.insan_360_website.data.page_states.AuthState
import org.zest.insan_360_website.data.page_states.dashboard.StudentsDashboardState.fetchInvitesList
import org.zest.insan_360_website.data.page_states.dashboard.StudentsDashboardState.fetchStudentsInfoList
import org.zest.insan_360_website.data.page_states.dashboard.StudentsDashboardState.needUpdate
import org.zest.insan_360_website.components.widgets.RoleGate
import org.zest.insan_360_website.model.UserRole
import org.zest.insan_360_website.pages.user.students_layout.AdminLayout

@Page
@Layout(".components.layouts.UserDashboardLayout")
@Composable
fun StudentsPage(ctx: PageContext) { // admin only
    val scope = rememberCoroutineScope()
    RoleGate(UserRole.ADMIN, ctx = ctx) {
        LaunchedEffect(Unit) {
            fetchInvitesList(scope)
        }
        LaunchedEffect(needUpdate) {
            if (needUpdate) {
                fetchStudentsInfoList(scope)
                needUpdate = false
            }
        }
        AdminLayout()
    }
}